<app-side-nav mode="swap"
              [selectedNetwork]="chainId ?? seoChainId ?? 1"
              (currencyChange)="onCurrencyChanged($event)"
              (networkChange)="changeChain($event)">
</app-side-nav>
<div class="p-4 max-w-xl mx-auto">
  <div class="md:hidden fixed top-0 left-0 right-0 z-40"
       [style.height.px]="headerHpx || 72"
       [ngClass]="!isDarkMode() ? 'bg-white' : 'bg-[#111827]'">
  </div>

  <!-- 🔹 HEADER MOBILE (fixe, centré, coins arrondis) – premium violet (light only) -->
  <div class="md:hidden fixed top-0 left-0 right-0 z-50 px-4 pt-[env(safe-area-inset-top)]">
    <div #mobileHeader
         class="max-w-md mx-auto rounded-2xl p-4 border transition-all backdrop-blur-md shadow-md transition-opacity duration-700 ease-in-out"
         [ngClass]="isDarkMode()
         ? 'bg-[#1e1e2f] border-indigo-500/10'
         : 'bg-gradient-to-b from-purple-50 to-indigo-50 border-purple-100 shadow-[0_6px_24px_rgba(123,97,255,0.06)]'">

      <!-- Ligne 1 : Titre -->
      <div class="flex items-center gap-2 mb-3">
        <svg class="w-6 h-6 md:w-7 md:h-7"
             [ngClass]="invBridgeLogo"
             fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
        <h1 class="text-lg font-extrabold tracking-tight text-purple-600 drop-shadow-[0_1px_2px_rgba(0,0,0,0.25)]">
          SwapTokens.app
        </h1>
      </div>

      <!-- Ligne 2 : Wallet + Thème -->
      <div class="flex items-center justify-between px-1">
        <!-- Wallet -->
        <app-connect-wallet-legacy #legacyConnect (connected)="onLegacyConnected($event)"
                                   (disconnected)="onLegacyDisconnected()" [takerAddress]="takerAddress"
                                   [addLog]="onChildLogConsole"
                                   [dark]="isDarkMode()">
        </app-connect-wallet-legacy>

        <!-- Theme -->
        <button (click)="toggleTheme()"
                class="flex items-center justify-center px-3 py-1 rounded-full border transition"
                [ngClass]="isDarkMode()
                ? 'border-white/10 bg-purple-400/10'
                : 'border-purple-200 bg-white/80 hover:bg-white'">
          <svg *ngIf="isDarkMode(); else lightIcon" class="w-5 h-5 text-purple-300" fill="none"
               stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
          </svg>
          <ng-template #lightIcon>
            <svg class="w-5 h-5 text-purple-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="5" />
              <line x1="12" y1="1" x2="12" y2="3" />
              <line x1="12" y1="21" x2="12" y2="23" />
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
              <line x1="1" y1="12" x2="3" y2="12" />
              <line x1="21" y1="12" x2="23" y2="12" />
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
            </svg>
          </ng-template>
        </button>
      </div>
    </div>
  </div>


  <!-- Spacer mobile auto (UN SEUL) -->
  <div class="md:hidden" [style.height.px]="headerHpx || 72"></div>

  <!-- <div class="hidden md:block"> ... ton header desktop actuel ... </div> -->
  <!-- 🔥 Nouveau HEADER inspiré MetaMask/eToro mobile – version premium violet -->
  <div class="hidden md:block relative mb-4 rounded-2xl overflow-hidden">
    <!-- Carte visible -->
    <div class="relative rounded-2xl p-4 border transition-all backdrop-blur-md hover:border-purple-400/20
              transition-opacity duration-700 ease-in-out"
         [ngClass]="isDarkMode()
         ? 'bg-[#1e1e2f]/70 border-indigo-500/10 shadow-md dark:shadow-purple-900/10'
         : 'bg-gradient-to-b from-purple-50 to-indigo-50 border-purple-100 shadow-[0_6px_24px_rgba(123,97,255,0.06)]'">

      <!-- 🔹 Ligne Logo + Wallet -->
      <div class="flex justify-between items-center gap-4 mb-3">
        <div class="flex items-center gap-2">
          <svg class="w-6 h-6 md:w-7 md:h-7" [ngClass]="invBridgeLogo" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>

          <!-- Titre avec gradient violet clair en mode light -->
          <h1 class="text-base sm:text-lg md:text-2xl font-extrabold bg-clip-text text-transparent"
              [ngClass]="isDarkMode()
              ? invBridgeGradient
              : 'bg-gradient-to-r from-purple-600 to-indigo-600'">
            SwapTokens.app
          </h1>
        </div>

        <!-- 🔐 Wallet Badge -->
        <app-connect-wallet-legacy (connected)="onLegacyConnected($event)" [addLog]="onChildLogConsole"
                                   (disconnected)="onLegacyDisconnected()" [takerAddress]="takerAddress" [dark]="isDarkMode()">
        </app-connect-wallet-legacy>
      </div>

      <!-- Bouton thème (mobile only, inchangé) -->
      <div class="md:hidden flex justify-end">
        <button (click)="toggleTheme()"
                class="p-1 rounded-full transition focus:outline-none focus:ring-0">
          <svg *ngIf="isDarkMode(); else lightIcon" class="w-6 h-6 md:w-7 md:h-7 text-purple-300" fill="none" stroke="currentColor" stroke-width="2"
               viewBox="0 0 24 24">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
          </svg>
          <ng-template #lightIcon>
            <svg class="w-6 h-6 md:w-7 md:h-7 text-purple-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="5" />
              <line x1="12" y1="1" x2="12" y2="3" />
              <line x1="12" y1="21" x2="12" y2="23" />
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
              <line x1="1" y1="12" x2="3" y2="12" />
              <line x1="21" y1="12" x2="23" y2="12" />
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
            </svg>
          </ng-template>
        </button>
      </div>
    </div>
  </div>

  <div class="rounded-2xl p-3 border shadow-md transition-all backdrop-blur-md mb-1
              transition-opacity duration-700 ease-in-out"
       [ngClass]="isDarkMode() ? 'bg-[#1e1e2f]/70 border-indigo-500/10 dark:shadow-purple-900/10' : 'bg-gradient-to-b from-purple-50 to-indigo-50 border-purple-100 shadow-[0_6px_24px_rgba(123,97,255,0.06)]'">
    <div>
      <!-- 🔹 Cas 1 : SEO dispo -->
      <ng-container *ngIf="tBase; else compareDefault">
        <div class="w-full px-4 py-3 rounded-2xl shadow-md backdrop-blur-md border text-center
              bg-gradient-to-r from-purple-500 via-purple-600 to-indigo-600 text-white"
             [ngClass]="isDarkMode() ? 'border-indigo-400/20' : 'border-indigo-500/10 shadow-xl'">

          <!-- SEO Titre -->
          <div class="text-[12px] md:text-[15px] font-semibold leading-[1.25] tracking-[.02em]
                     drop-shadow-[0_1px_1px_rgba(0,0,0,0.25)] max-w-[28ch] mx-auto">
            {{ editorialH1 || (tBase + '.H1' | translate) }}
          </div>

          <!-- SEO Body -->
          <div class="mt-1 text-[11px] md:text-[13px] opacity-90 leading-[1.35] max-w-[32ch] mx-auto">
            {{ editorialBody || (tBase + '.EDITORIAL' | translate) }}
          </div>
        </div>
      </ng-container>

      <!-- 🔹 Cas 2 : Pas de SEO → fallback compare exchanges -->
      <ng-template #compareDefault>
        <div class="w-full px-4 py-3 rounded-2xl shadow-md backdrop-blur-md border text-center
              bg-gradient-to-r from-purple-500 via-purple-600 to-indigo-600 text-white"
             [ngClass]="isDarkMode() ? 'border-indigo-400/20' : 'border-indigo-500/10 shadow-xl'">

          <div class="text-[12px] md:text-[15px] font-semibold leading-[1.25] tracking-[.02em]
                      drop-shadow-[0_1px_1px_rgba(0,0,0,0.25)] max-w-[28ch] mx-auto">
            {{ 'COMPARE_EXCHANGES' | translate }}
          </div>

          <div class="mt-1 text-[11px] md:text-[13px] opacity-90 leading-[1.35] max-w-[32ch] mx-auto">
            {{ 'COMPARE_EXCHANGES_DETAILS' | translate }}
          </div>
        </div>
      </ng-template>

    </div>

    <!-- Ligne titre --> <div class="flex justify-between items-baseline mb-2 mt-4">
      <h3 class="flex items-center gap-2 text-[11px] md:text-xs font-medium uppercase tracking-[.12em]"
          [ngClass]="isDarkMode() ? 'text-white/80' : 'text-gray-800/80'">
        <!-- puce dégradée, discrète -->
        <svg class="w-2.5 h-2.5 rounded-full" viewBox="0 0 10 10" fill="none">

          <circle cx="5" cy="5" r="5" class="fill-[url(#g1)]" />

          <defs>

            <linearGradient id="g1" x1="0" y1="0" x2="10" y2="10">

              <stop offset="0" stop-color="#7C3AED" />
              <stop offset="1" stop-color="#4F46E5" />

            </linearGradient>

          </defs>

        </svg>
        {{ 'SELL_AMOUNT' | translate }}

      </h3>

      <!-- 🌐 Sélecteur Réseau – style “libellé” (puce + icône + nom) -->
      <div class="relative h-7 flex items-center">
        <button type="button"
                #chainTrigger
                (click)="$event.stopPropagation(); showChainMenu = !showChainMenu"
                class="inline-flex items-center gap-2 h-7 px-1.5 rounded-md
                 text-[11px] md:text-xs font-medium uppercase tracking-[.12em]
                 transition-colors"
                [ngClass]="isDarkMode()
            ? 'text-white/80 hover:text-white'
            : 'text-gray-800/80 hover:text-gray-900'">
          <!-- puce violette -->
          <span class="w-2.5 h-2.5 rounded-full bg-gradient-to-r from-purple-500 to-indigo-500"></span>
          <!-- icône réseau (disque blanc si Ethereum) -->
          <span class="relative inline-flex items-center justify-center w-5 h-5 rounded-full"
                [ngClass]="(chainId || 1) === 1
 ? (isDarkMode() ? 'bg-white ring-1 ring-white/10' : 'bg-white')
: 'bg-transparent'">
            <img [src]="CHAIN_MAP[chainId || 1]?.icon"
                 class="w-3.5 h-3.5 rounded-full object-contain" />
          </span>
          <!-- nom réseau -->
          <span class="whitespace-nowrap">{{ CHAIN_MAP[chainId || 1]?.name }}</span>
          <!-- chevron -->
          <svg class="w-3 h-3 opacity-70"
               [ngClass]="isDarkMode() ? 'text-purple-300' : 'text-purple-500'"
               viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd"
                  d="M5.23 7.21a.75.75 0 011.06.02L10 11.293l3.71-4.06a.75.75 0 111.08 1.04l-4.25 4.66a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z"
                  clip-rule="evenodd" />
          </svg>
        </button>

        <!-- Dropdown réseaux -->
        <ul *ngIf="showChainMenu"
            #chainMenuRoot
            class="absolute top-full right-0 mt-1 w-[max(128px,100%)] rounded-xl border z-30 overflow-hidden text-xs shadow-xl"
            [ngClass]="isDarkMode()
        ? 'bg-gray-900 border-purple-700/70 text-white'
        : 'bg-white border-gray-200 text-gray-800'">
          <!-- Dropdown réseaux (uniquement <li> modifié) -->
          <li *ngFor="let id of [1,137,42161,56]"
              (click)="changeChain(id); showChainMenu = false"
              class="px-2 py-1.5 cursor-pointer flex items-center justify-between gap-2 transition-colors"
              [ngClass]="(chainId || 1) === id
      ? (isDarkMode() ? 'bg-purple-600/15' : 'bg-indigo-50')
      : (isDarkMode() ? 'hover:bg-purple-600/10' : 'hover:bg-indigo-50')">
            <div class="flex items-center gap-2">
              <!-- 🔹 PUCE SUPPRIMÉE ICI -->
              <img [src]="CHAIN_MAP[id].icon" class="w-4 h-4 rounded-full" />
              <span class="whitespace-nowrap text-[11px] tracking-[.02em]">
                {{ CHAIN_MAP[id].name }}
              </span>
            </div>
            <!-- check sélection -->
            <svg *ngIf="(chainId || 1) === id" class="w-3.5 h-3.5"
                 [ngClass]="isDarkMode() ? 'text-purple-300' : 'text-purple-600'"
                 viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </li>

        </ul>
      </div>

    </div>


    <div [ngClass]="isDarkMode()
  ? 'mt-2 md:mt-3'
  : 'mt-2 md:mt-3 border-t border-gray-200/60'"></div>

    <!-- Montant à vendre -->

    <div class="relative w-full min-w-0">
      <input type="text" appFocusScrollGuard appDecimalCommaFix
             [commaFixLog]="addLog.bind(this)"
             inputmode="decimal"
             enterkeyhint="done"
             autocomplete="off"
             autocorrect="off"
             spellcheck="false"
             class="block w-full h-13 px-4 pr-24 rounded-2xl transition-all
     font-medium tracking-tight leading-tight
     text-[17px] md:text-base
     [font-variant-numeric:tabular-nums] caret-purple-500
     placeholder:text-gray-400/70 selection:bg-purple-200 selection:text-gray-900
     shadow-[0_2px_10px_rgba(123,97,255,0.06)] focus:outline-none"
             [ngClass]="isDarkMode()
? 'border border-purple-600 dark:bg-gray-800 text-white focus:ring-2 focus:ring-purple-500/30'
: 'border border-purple-200 text-gray-900 focus:ring-2 focus:ring-purple-400/25 focus:border-purple-300'"
             [(ngModel)]="sellAmount"
             placeholder="0" />



      <!-- Fiat équivalent (dynamique) -->
      <div class="absolute top-1  right-4 text-[10px] md:text-xs [font-variant-numeric:tabular-nums]"
           [ngClass]="isDarkMode() ? 'text-white/80' : 'text-gray-900/80'">
        <ng-container *ngIf="!fiatLoading; else fiatInputSkel">
          {{ getSellFiatValue() }}
        </ng-container>
        <ng-template #fiatInputSkel>
          <span class="inline-block align-middle w-16 h-3 rounded
                   bg-slate-200/50 dark:bg-slate-700/40 animate-pulse"></span>
        </ng-template>
      </div>
    </div>




    <!-- Sélecteur Token -->
    <div class="mt-2 md:mt-4">
      <button type="button"
              (click)="showTokenModal = true"
              class="w-full flex items-center justify-between px-4 py-3 rounded-2xl transition shadow-sm"
              [ngClass]="isDarkMode()
      ? 'border border-purple-600 bg-gray-800'
      : 'border border-purple-200 bg-white/95 shadow-[0_2px_10px_rgba(123,97,255,0.06)]'">

        <div class="flex items-center gap-2" [ngClass]="isDarkMode() ? 'text-white' : 'text-gray-900'">
          <div class="rounded-full "
               [ngClass]="hasWhiteDisk(sellTokenSymbol) ? 'bg-white' : 'bg-transparent'">
            <img [ngSrc]="getTokenLogo(sellTokenSymbol)"
                 [attr.alt]="'Logo ' + getTokenLabel(sellTokenSymbol)"
                 [width]="tokenImgSize" [height]="tokenImgSize"
                 priority
                 [attr.fetchpriority]="isCriticalAboveTheFold ? 'high' : 'low'"
                 class="w-5 h-5 md:w-6 md:h-6 rounded-full object-contain" />
          </div>

          <span class="font-normal leading-[1.15] text-[11px] md:text-sm" [ngClass]="isDarkMode() ? 'text-white/90' : 'text-gray-800/90'">
            {{ getTokenLabel(sellTokenSymbol) }}
          </span>
        </div>


        <span class="text-[10px] md:text-xs [font-variant-numeric:tabular-nums]" [ngClass]="isDarkMode() ? 'text-white/80' : 'text-gray-900/80'">
          <ng-container *ngIf="!balancesLoading; else balSellSkel">
            {{ getTokenBalance(sellTokenSymbol) || '' }}
          </ng-container>
          <ng-template #balSellSkel>
            <span class="inline-block align-middle w-14 h-3 rounded
              bg-slate-200/50 dark:bg-slate-700/40 animate-pulse"></span>
          </ng-template>
        </span>

      </button>
    </div>




    <div class="flex justify-between items-baseline mt-2 md:mt-4">
      <!-- Titre BUY_TOKEN -->
      <h3 class="flex items-center gap-2 text-[11px] md:text-xs font-medium uppercase tracking-[.12em]"
          [ngClass]="isDarkMode() ? 'text-white/80' : 'text-gray-800/80'">
        <svg class="w-2.5 h-2.5 rounded-full" viewBox="0 0 10 10" fill="none">

          <circle cx="5" cy="5" r="5" class="fill-[url(#g2)]" />

          <defs>

            <linearGradient id="g2" x1="0" y1="0" x2="10" y2="10">

              <stop offset="0" stop-color="#7C3AED" />
              <stop offset="1" stop-color="#4F46E5" />

            </linearGradient>

          </defs>

        </svg>
        {{ 'BUY_TOKEN' | translate }}

      </h3>


    </div>

    <div [ngClass]="isDarkMode()
  ? 'mt-2 md:mt-3'
  : 'mt-2 md:mt-3 border-t border-gray-200/60'"></div>

    <!-- Sélecteur Token (buy) -->
    <button type="button"
            (click)="showBuyTokenModal = true"
            class="w-full flex items-center justify-between px-4 py-3 rounded-2xl transition shadow-sm"
            [ngClass]="isDarkMode()
    ? 'border border-purple-600 bg-gray-800'
    : 'border border-purple-200 bg-white/95 shadow-[0_2px_10px_rgba(123,97,255,0.06)]'">

      <div class="flex items-center gap-2">
        <div class="rounded-full "
             [ngClass]="hasWhiteDisk(buyTokenSymbol) ? 'bg-white' : 'bg-transparent'">
          <img [ngSrc]="getTokenLogo(buyTokenSymbol)"
               [attr.alt]="'Logo ' + getTokenLabel(buyTokenSymbol)"
               [width]="tokenImgSize" [height]="tokenImgSize"
               priority
               [attr.fetchpriority]="isCriticalAboveTheFold ? 'high' : 'low'"
               class="w-5 h-5 md:w-6 md:h-6 rounded-full object-contain" />
        </div>

        <span class="font-normal leading-[1.15] text-[11px] md:text-sm" [ngClass]="isDarkMode() ? 'text-white/90' : 'text-gray-800/90'">
          {{ getTokenLabel(buyTokenSymbol) }}
        </span>
      </div>


    </button>


    <!-- Dropdown tokens -->
    <ul *ngIf="showBuyDropdown"
        class="mt-2 rounded-xl shadow-lg max-h-60 overflow-y-auto transition"
        [ngClass]="isDarkMode()
          ? 'border border-gray-700 bg-gray-900'
          : 'border border-purple-200 bg-white'">
      <li *ngFor="let token of filteredBuyTokens; trackBy: trackBySymbol" ...>
        <div class="flex items-center gap-2 font-bold" ...>
          <img [ngSrc]="getTokenLogo(token.symbol)"
               [attr.alt]="'Logo ' + getTokenLabel(token.symbol)"
               width="20" height="20"
               loading="lazy" decoding="async"
               class="w-5 h-5 rounded-full" />
          {{ getTokenLabel(token.symbol) }} – {{ token.name }}
        </div>
      </li>
    </ul>





  </div>
  <!-- 🔄 Bouton Obtenir le meilleur taux -->
  <button *ngIf="isSwap"
          class="w-full py-4 rounded-xl font-medium text-white
        text-[11px] md:text-[13px]
        shadow-md hover:brightness-110 active:scale-[.99]
        transition focus:outline-none focus-visible:ring-2 focus-visible:ring-white/30
        disabled:opacity-60 disabled:cursor-not-allowed
        bg-gradient-to-r from-purple-500 via-purple-600 to-indigo-600"
          [disabled]="isLoadingQuote || !sellAmount || !sellTokenSymbol || !buyTokenSymbol"
          (click)="fetchQuote()"
          type="button"
          style="background-color: transparent;">
    <ng-container *ngIf="!isLoadingQuote; else loading">
      {{ ctaLabel || ('GET_BEST_RATE' | translate) }}
    </ng-container>
    <ng-template #loading>
      <svg class="animate-spin h-5 w-5 mx-auto text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
           viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
      </svg>
    </ng-template>
  </button>

  <!-- FORMULAIRE -->
  <div class="flex flex-col gap-4 mt-4">


    <div *ngIf="showDebug"
         class="fixed left-3 right-3 bottom-14 z-[9998] p-3 rounded-lg border bg-black/80 text-xs text-white overflow-auto"
         [style.maxHeight.px]="isDebugCollapsed ? 40 : 256">

      <div class="flex justify-between items-center mb-1">
        <div class="flex items-center gap-2">
          <span class="font-semibold">Debug Connect</span>
          <button (click)="isDebugCollapsed = !isDebugCollapsed"
                  class="px-2 py-0.5 bg-gray-700 text-white rounded text-xs hover:bg-gray-600 active:bg-gray-800">
            {{ isDebugCollapsed ? '▼' : '▲' }}
          </button>
        </div>
        <button (click)="copyDebugLogs()"
                class="px-2 py-1 bg-indigo-500 text-white rounded text-xs hover:bg-indigo-600 active:bg-indigo-700">
          📋 Copier
        </button>
      </div>

      <pre *ngIf="!isDebugCollapsed" style="white-space: pre-wrap">{{ debugText }}</pre>
    </div>







    <!-- ▶️ OVERLAY plein écran dès qu'on a une quote -->
    <!--<div *ngIf="quote"
    class="fixed inset-0 z-[100] bg-black/60"
    (click)="closeQuote()">-->
    <!-- Panneau scrollable interne (empêche le scroll du body) -->
    <!--<div class="absolute inset-0 overflow-y-auto"
       style="overscroll-behavior: contain;"
       (click)="$event.stopPropagation()">

    <div class="min-h-[100dvh] p-3 md:p-6
            pt-[calc(env(safe-area-inset-top)+12px)]
            pb-[calc(env(safe-area-inset-bottom)+12px)]">
      <div class="mx-auto max-w-3xl">-->
    <!-- Barre d’action sticky (optionnelle) -->
    <!--<div class="sticky top-0 z-[101] -mx-1 mb-3 flex items-center justify-end
            px-3 py-2 rounded-xl backdrop-blur-md border
            bg-white/70 dark:bg-slate-900/70 border-white/20">
      <button class="rounded-lg px-3 py-1 border"
              (click)="closeQuote()">
        Fermer
      </button>
    </div>-->
    <!-- ✅ Ton composant existant, inchangé -->
    <!--<app-quote-preview-v3 [quote]="quote"
                                  [signature]="signature || ''"
                                  (copyToClipboard)="signature ? copyToClipboard(signature) : null"
                                  (signRequest)="simulateSwap()"
                                  [swapStatus]="swapStatus"
                                  [swapHash]="swapHash"
                                  [swapDisabled]="isSwapDisabled()"
                                  [swapError]="swapError"
                                  [nativeTokenUsd]="nativeTokenUsd"
                                  [gasPriceWei]="gasPriceWei"
                                  [fullGasWei]="fullGasWei"
                                  [fiatCode]="defaultFiat"
                                  [fiatRates]="fiatRates"
                                  (executeRequest)="executeSwap()"
                                  (selectAlternative)="onAlternativeSelected($event)"
                                  [validateAlternative]="validateAlternativeRoute"
                                  (close)="closeQuote();scrollToTop()">
            </app-quote-preview-v3>

          </div>
        </div>
      </div>
    </div>-->
    <div *ngIf="quote"
         class="fixed inset-0 z-[9998] bg-black/60 backdrop-blur-sm overflow-y-auto overscroll-contain"
         role="dialog"
         aria-modal="true"
         tabindex="0"
         style="padding-top: env(safe-area-inset-top); padding-bottom: env(safe-area-inset-bottom); overscroll-behavior: contain;"
         (click)="closeQuoteUI('backdrop-click')"
         (keydown.escape)="closeQuoteUI('escape-key')">
      <!-- Contenu (empêche la fermeture si on clique sur la carte) -->
      <div class="min-h-full flex items-start md:items-center justify-center p-3 md:p-6 overscroll-contain"
           (click)="$event.stopPropagation()">
        <div class="w-full md:max-w-2xl">
          <app-quote-preview-v4 *ngIf="quote"
                                [takerAddress]="takerAddress"
                                [needsApproval]="needsApprovalMain"
                                [needsApprovalForAlt]="needsApprovalForAlt"
                                [bypassDebug]="debugBypassGasCheck"
                                [validatingKey]="validatingKey"
                                (requestConnect)="onQuoteRequestConnect()"
                                [quote]="quote"
                                [signature]="signature || ''"
                                (copyToClipboard)="signature ? copyToClipboard(signature) : null"
                                (signRequest)="simulateSwap()"
                                [swapStatus]="swapStatus"
                                [swapHash]="swapHash"
                                [swapDisabled]="isSwapDisabled()"
                                [swapError]="swapError"
                                [nativeTokenUsd]="nativeTokenUsd"
                                [nativeBalanceWei]="currentNativeBalanceWei"
                                [gasPriceWei]="gasPriceWei"
                                [fullGasWei]="fullGasWeiForChild"
                                [fiatCode]="defaultFiat"
                                [fiatRates]="fiatRates"
                                (executeRequest)="onClickExecuteSwap()"
                                (selectAlternative)="onAlternativeSelected($event)"
                                [validateAlternative]="validateAlternativeRoute"
                                [bridgeReasons]="swapReasons"
                                (close)="closeQuoteUI('child-close'); scrollToTop()">
          </app-quote-preview-v4>
        </div>
      </div>
    </div>


    <!-- ✅ Ton composant existant, inchangé -->
    <!--<app-quote-preview-v3 *ngIf="quote" [quote]="quote"
                          [signature]="signature || ''"
                          (copyToClipboard)="signature ? copyToClipboard(signature) : null"
                          (signRequest)="simulateSwap()"
                          [swapStatus]="swapStatus"
                          [swapHash]="swapHash"
                          [swapDisabled]="isSwapDisabled()"
                          [swapError]="swapError"
                          [nativeTokenUsd]="nativeTokenUsd"
                          [gasPriceWei]="gasPriceWei"
                          [fullGasWei]="fullGasWei"
                          [fiatCode]="defaultFiat"
                          [fiatRates]="fiatRates"
                          (executeRequest)="executeSwap()"
                          (selectAlternative)="onAlternativeSelected($event)"
                          [validateAlternative]="validateAlternativeRoute"
                          (close)="closeQuote();scrollToTop()">
    </app-quote-preview-v3>-->
    <!--<app-quote-preview-v2 *ngIf="quote"
                          [quote]="quote"
                          [signature]="signature || ''"
                          (copyToClipboard)="signature ? copyToClipboard(signature) : null"
                          (signRequest)="simulateSwap()"
                          [swapStatus]="swapStatus"
                          [swapHash]="swapHash"
                          [swapDisabled]="isSwapDisabled()"
                          [swapError]="swapError"
                          [nativeTokenUsd]="nativeTokenUsd"
                          [gasPriceWei]="gasPriceWei"
                          [fullGasWei]="fullGasWei"
                          [fiatCode]="defaultFiat"
                          [fiatRates]="fiatRates"
                          (executeRequest)="executeSwap()"
                          (selectAlternative)="onAlternativeSelected($event)"
                          [validateAlternative]="validateAlternativeRoute"
                          class="mt-6 block"
                          (close)="closeQuote();scrollToTop()">
    </app-quote-preview-v2>-->
    <!-- 📦 Aperçu quote -->
    <!--<app-quote-preview *ngIf="quote"
                       [quote]="quote"
                       [signature]="signature || ''"
                       (copyToClipboard)="signature ? copyToClipboard(signature) : null"
                       (signRequest)="simulateSwap()"
                       [swapStatus]="swapStatus"
                       [swapHash]="swapHash"
                       [swapDisabled]="isSwapDisabled()"
                       [swapError]="swapError"
                       [nativeTokenUsd]="nativeTokenUsd"
                       [gasPriceWei]="gasPriceWei"
                       [fullGasWei]="fullGasWei"
                       [fiatCode]="defaultFiat"
                       [fiatRates]="fiatRates"
                       (executeRequest)="executeSwap()"
                       (selectAlternative)="onAlternativeSelected($event)"
                       [validateAlternative]="validateAlternativeRoute"
                       class="mt-6 block"
                       (close)="closeQuote();scrollToTop()">
    </app-quote-preview>-->
    <!--<div *ngIf="quote && swapDisabled && swapReasons?.length"
       class="mt-4 rounded-xl border border-purple-200 bg-purple-50 dark:border-purple-500/20 dark:bg-purple-900/20 p-4 space-y-2">

    <div *ngFor="let r of (swapReasons.includes('WALLET_DISCONNECTED') ? ['WALLET_DISCONNECTED'] : swapReasons)"
         class="flex items-start gap-2">
      <svg class="w-3 h-3 text-purple-200 mt-1 flex-shrink-0" fill="currentColor" viewBox="0 0 8 8">
        <circle cx="4" cy="4" r="4" />
      </svg>-->
    <!--<span class="text-sm text-gray-800 dark:text-gray-200">
    <ng-container [ngSwitch]="r">

      <span *ngSwitchCase="'WALLET_DISCONNECTED'" class="inline-flex items-center gap-2">
        {{ 'BRIDGE_REASON_WALLET_DISCONNECTED' | translate }}

        <button (click)="connectWallet()"
                class="inline-flex items-center justify-center w-7 h-7 rounded-full
           bg-gradient-to-r from-purple-600 to-indigo-600 text-white
           shadow-md hover:opacity-90 transition"
                aria-label="Connect Wallet">
          <svg viewBox="0 0 24 24" fill="none"
               stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
               class="w-[18px] h-[18px] flex-shrink-0">
            <path d="M12 3v7" />
            <path d="M6.2 7.8a8 8 0 1 0 11.6 0" />
          </svg>
        </button>
      </span>


      <span *ngSwitchCase="'INVALID_AMOUNT'">
        {{ 'BRIDGE_REASON_INVALID_AMOUNT' | translate }}
      </span>

      <span *ngSwitchCase="'INSUFFICIENT_NATIVE_GAS'">
        {{ 'BRIDGE_REASON_INSUFFICIENT_NATIVE_GAS' |  translate:{ symbol: getNativeTokenSymbol(chainId || 1) } }}
      </span>

      <span *ngSwitchCase="'INSUFFICIENT_SELL_TOKEN'">
        {{ 'BRIDGE_REASON_INSUFFICIENT_SELL_TOKEN' | translate:{ token: sellTokenSymbol  } }}
      </span>-->
    <!-- fallback -->
    <!--<span *ngSwitchDefault>{{ r }}</span>

      </ng-container>
    </span>-->
    <!--</div>
    </div>-->
    <div class="h-6 sm:h-7"></div>
    <!-- 📊 Stats (sous le CTA) -->
    <div class="mt-6 space-y-3">
      <!-- Tokens -->
      <div class="relative">
        <!-- Glow/ombre colorée -->
        <div class="absolute inset-0 rounded-2xl"
             [ngClass]="isDarkMode()
           ? 'translate-x-1 translate-y-1 bg-gradient-to-r from-purple-600 to-indigo-600 opacity-80'
           : 'bg-gradient-to-r from-purple-300 to-indigo-300 opacity-50 blur-[2px]'">
        </div>

        <div class="relative rounded-2xl px-4 py-3 border shadow-sm transition-all backdrop-blur-md"
             [ngClass]="isDarkMode()
           ? 'bg-[#111827]/90 border-white/10'
           : 'bg-white/80 border-gray-200'">
          <div class="flex items-center justify-between">
            <div class="text-[11px] uppercase tracking-wide font-semibold"
                 [ngClass]="isDarkMode() ? 'text-white' : 'text-gray-700'">
              {{ 'STATS.TOKENS.TITLE' | translate }}
            </div>

            <div class="text-xl font-extrabold tracking-wide bg-clip-text text-transparent"
                 [ngClass]="isDarkMode()
               ? 'bg-gradient-to-r from-purple-400 to-indigo-400'
               : 'bg-gradient-to-r from-purple-600 to-indigo-700'">
              2 145+
            </div>
          </div>

          <div class="mt-1 text-sm"
               [ngClass]="isDarkMode() ? 'text-white/80' : 'text-gray-600'">
            {{ 'STATS.TOKENS.SUBTITLE' | translate }}
          </div>
        </div>
      </div>

      <!-- LI.FI numbers -->
      <div class="relative">
        <!-- Glow/ombre colorée -->
        <div class="absolute inset-0 rounded-2xl"
             [ngClass]="isDarkMode()
           ? 'translate-x-1 translate-y-1 bg-gradient-to-r from-indigo-600 to-purple-600 opacity-80'
           : 'bg-gradient-to-r from-indigo-300 to-purple-300 opacity-50 blur-[2px]'">
        </div>

        <div class="relative rounded-2xl px-4 py-3 border shadow-sm transition-all backdrop-blur-md"
             [ngClass]="isDarkMode()
           ? 'bg-[#111827]/90 border-white/10'
           : 'bg-white/80 border-gray-200'">
          <div class="flex items-center justify-between">
            <div class="text-[11px] uppercase tracking-wide font-semibold"
                 [ngClass]="isDarkMode() ? 'text-white' : 'text-gray-700'">
              {{ 'STATS.LIFI.TITLE' | translate }}
            </div>

            <div class="text-xl font-extrabold bg-clip-text text-transparent"
                 [ngClass]="isDarkMode()
               ? 'bg-gradient-to-r from-indigo-400 to-purple-400'
               : 'bg-gradient-to-r from-indigo-700 to-purple-700'">
              $30B+
            </div>
          </div>

          <div class="mt-1 text-sm font-semibold bg-clip-text text-transparent"
               [ngClass]="isDarkMode()
             ? 'bg-gradient-to-r from-purple-300 to-indigo-300'
             : 'bg-gradient-to-r from-purple-700 to-indigo-700'">
            {{ 'STATS.LIFI.SECURED' | translate }}
          </div>

          <!-- Badge certifié -->
          <div class="mt-2 inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-[11px] font-semibold border shadow-sm"
               [ngClass]="isDarkMode()
             ? 'bg-gradient-to-r from-purple-600 to-indigo-600 text-white border-white/10'
             : 'bg-gradient-to-r from-purple-600 to-indigo-600 text-white border-gray-200'">
            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 12l2 2 4-4m5 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>{{ 'STATS.LIFI.POWERED' | translate }}</span>
          </div>
        </div>
      </div>
    </div>




  </div>


  <!-- 🔻 Footer "sticky" + offset clavier dynamique -->
  <div class="sticky -mx-4 md:mx-0 z-60"
       [style.bottom.px]="kbOffset">
    <div class="md:hidden h-20"></div>
    <app-footer-nav #footerHost
                    mode="default"
                    [hideOnKeyboard]="false"
                    (settingsClick)="showSettings = !showSettings"
                    (infoClick)="toggleFooterMenu()">

    </app-footer-nav>

  </div>

</div>


<!-- Backdrop (clique dehors => ferme) -->
<div *ngIf="showFooterMenu"
     class="fixed inset-0 z-[59]"
     (click)="closeFooterMenu()"></div>

<!-- Sous-menu Info (mobile) -->
<ul *ngIf="showFooterMenu"
    class="fixed z-[10000] bottom-[72px] left-4 w-[90vw] max-w-xs rounded-2xl shadow-lg border transition-all duration-300 ease-in-out
     backdrop-blur-md backdrop-saturate-150"
    [ngClass]="isDarkMode()
      ? 'bg-gray-900/20 text-white border-white/10'
      : 'bg-white/20 text-gray-800 border-black/10'"
    (click)="$event.stopPropagation()">
  <li>
    <a routerLink="/a-propos"
       (click)="showFooterMenu = false"
       class="block px-4 py-3 rounded-lg border border-transparent hover:border-purple-500 transition duration-200 text-sm font-semibold"
       [ngClass]="isDarkMode() ? 'text-purple-300' : 'text-purple-700'">
      {{ 'ABOUT' | translate }}
    </a>
  </li>

  <li>
    <a routerLink="/disclaimer"
       (click)="showFooterMenu = false"
       class="block px-4 py-3 rounded-lg border border-transparent hover:border-purple-500 transition duration-200 text-sm font-semibold"
       [ngClass]="isDarkMode() ? 'text-purple-300' : 'text-purple-700'">
      {{ 'DISCLAIMER_NAV' | translate }}
    </a>
  </li>
</ul>
<app-settings *ngIf="showSettings" class="fixed bottom-[260px] right-4 z-[9999] w-[300px] rounded shadow-lg"
              (currencyChange)="onCurrencyChanged?.($event)"></app-settings>

<!-- ❌ plus de spacer fixe : l'espace est réservé par le padding du conteneur -->
<!--<div class="h-24 sm:h-28"></div>--> <!-- espace vide pour libérer la zone du footer -->
<!-- 🔻 Footer Fixe Mobile — opaque + collé en bas -->
<!--<div class="md:hidden fixed bottom-0 left-0 right-0 z-50"
     [ngClass]="isDarkMode()
       ? 'bg-[#111827]'
       : 'bg-white'">
  <div class="pb-[env(safe-area-inset-bottom)]">
    <div class="max-w-md mx-auto px-4">
      <div class="rounded-none p-3 border shadow-md transition-all"
           [ngClass]="isDarkMode()
             ? 'bg-[#1e1e2f] border-indigo-500/10 dark:shadow-purple-900/10'
             : 'bg-gradient-to-b from-purple-50 to-indigo-50 border-purple-100 shadow-[0_6px_24px_rgba(123,97,255,0.06)]'">

        <div class="flex justify-around items-center gap-3 text-sm">-->
<!-- 📋 Menu déroulant -->
<!--<div class="relative" #footerMenuRoot>
  <button (click)="showFooterMenu = !showFooterMenu"
          class="p-2 rounded-full transition"
          [ngClass]="isDarkMode() ? 'border-purple-400 text-purple-300' : 'border-purple-400 text-purple-600'">
    <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 10h16M4 14h16M4 18h16" />
    </svg>
  </button>-->
<!-- Sous-menu -->
<!--<ul *ngIf="showFooterMenu"
          class="fixed z-[10000] bottom-[72px] left-4 w-[90vw] max-w-xs rounded-2xl shadow-lg border transition-all duration-300 ease-in-out
     backdrop-blur-md backdrop-saturate-150"
          [ngClass]="isDarkMode()
? 'bg-gray-900/20 text-white border-white/10'
: 'bg-white/20 text-gray-800 border-black/10'">
        <li>
          <a routerLink="/"
             (click)="showFooterMenu = false"
             class="block px-4 py-3 rounded-lg border border-transparent hover:border-purple-500 transition duration-200 text-sm font-semibold"
             [ngClass]="isDarkMode() ? 'text-purple-300' : 'text-purple-700'">
            {{ 'SWAP' | translate }}
          </a>
        </li>
        <li>
          <a routerLink="/bridge"
             (click)="showFooterMenu = false"
             class="block px-4 py-3 rounded-lg border border-transparent hover:border-purple-500 transition duration-200 text-sm font-semibold"
             [ngClass]="isDarkMode() ? 'text-purple-300' : 'text-purple-700'">
            {{ 'BRIDGE' | translate }}
          </a>
        </li>
        <li>
          <a [routerLink]="['/', selectedLanguage, 'blog']"
             (click)="showFooterMenu = false"
             class="block px-4 py-3 rounded-lg border border-transparent hover:border-purple-500 transition duration-200 text-sm font-semibold"
             [ngClass]="isDarkMode() ? 'text-purple-300' : 'text-purple-700'">
            {{ 'BLOG_NAV' | translate }}
          </a>
        </li>
        <li>
          <a routerLink="/a-propos"
             (click)="showFooterMenu = false"
             class="block px-4 py-3 rounded-lg border border-transparent hover:border-purple-500 transition duration-200 text-sm font-semibold"
             [ngClass]="isDarkMode() ? 'text-purple-300' : 'text-purple-700'">
            {{ 'ABOUT' | translate }}
          </a>
        </li>
        <li>
          <a routerLink="/disclaimer"
             (click)="showFooterMenu = false"
             class="block px-4 py-3 rounded-lg border border-transparent hover:border-purple-500 transition duration-200 text-sm font-semibold"
             [ngClass]="isDarkMode() ? 'text-purple-300' : 'text-purple-700'">
            {{ 'DISCLAIMER_NAV' | translate }}
          </a>
        </li>
      </ul>
    </div>-->
<!-- 🌐 Sélecteur Réseau -->
<!--<div class="relative min-w-[130px] h-8 flex items-center" #chainTrigger>
  <button type="button"
          (click)="showChainMenu = !showChainMenu"
          class="flex items-center justify-between w-full px-2 py-1 h-8 rounded-xl text-xs font-medium border shadow-sm transition-all duration-200"
          [ngClass]="isDarkMode()
          ? 'bg-[#1e1e2f] text-white border-purple-400'
            : 'bg-white text-gray-800 border-purple-300'">
    <div class="flex items-center gap-2">
      <img *ngIf="chainInfo" [src]="chainInfo.icon" class="w-4 h-4 rounded-full shadow-sm" />
      <span class="whitespace-nowrap truncate max-w-[80px]">{{ chainInfo?.name }}</span>
    </div>
    <svg class="w-3 h-3 opacity-70" [ngClass]="isDarkMode() ? 'text-purple-300' : 'text-purple-500'" viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.293l3.71-4.06a.75.75 0 111.08 1.04l-4.25 4.66a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
    </svg>
  </button>
</div>-->
<!-- ⚙️ Paramètres -->
<!--<div class="relative inline-block" #settingsRoot>
            <button (click)="$event.stopPropagation();toggleSettings()" class="p-2 rounded-full transition"
                    [ngClass]="isDarkMode() ? 'border-purple-400 text-purple-300' : 'border-purple-300 text-purple-600'">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="3"></circle>
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06
                   a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09
                   a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83
                   l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09
                   a1.65 1.65 0 0 0 1.51-1z" />
              </svg>
            </button>

            <app-settings *ngIf="showSettings"
                          class="fixed bottom-[260px] right-4 z-[9999] w-[300px] rounded shadow-lg transition-all duration-300"
                          [ngClass]="isDarkMode() ? 'bg-gray-900' : 'bg-white'"
                          (currencyChange)="onCurrencyChanged($event)">
            </app-settings>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>-->
<!-- Wallet-Connect Modal -->
<div *ngIf="showWcModal"
     class="fixed inset-0 flex items-center justify-center bg-black/60 z-[10010]">
  <div class="bg-white dark:bg-gray-800 rounded-xl p-6 w-80 text-center">
    <h2 class="text-lg font-semibold mb-4">{{ 'wc.title' | translate }}</h2>
    <!-- QR code -->
    <img [src]="'https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=' + encodeURIComponent(wcUri)"
         alt="QR WalletConnect" class="mx-auto mb-4" />
    <a [href]="'https://metamask.app.link/wc?uri=' + encodeURIComponent(wcUri)"
       class="inline-block bg-indigo-600 text-white px-4 py-2 rounded-lg">
      {{ 'wc.openInMM' | translate }}
    </a>
    <p class="mt-4 text-xs opacity-70">
      {{ 'wc.hint' | translate }}
    </p>
    <button (click)="closeWcModal()"
            class="absolute top-2 right-2 text-gray-400 hover:text-gray-600">
      ✕
    </button>
  </div>
</div>
<app-token-selector [userTokens]="userCachedTokens"
                    [popularTokens]="popularTokens"
                    [tokenBalances]="tokenCachedBalances"
                    [priceMap]="priceMap"
                    [show]="showTokenModal"
                    [dark]="isDarkMode()"
                    (close)="showTokenModal = false"
                    [walletConnected]="!!takerAddress"
                    (tokenSelected)="selectSellToken($event)"
                    [selectedCurrency]="defaultFiat"
                    [fiatRates]="fiatRates">
</app-token-selector>


<app-token-selector [userTokens]="userCachedTokens"
                    [popularTokens]="popularTokens"
                    [tokenBalances]="tokenCachedBalances"
                    [priceMap]="priceMap"
                    [show]="showBuyTokenModal"
                    [dark]="isDarkMode()"
                    (close)="showBuyTokenModal = false"
                    [walletConnected]="!!takerAddress"
                    (tokenSelected)="selectBuyToken($event)"
                    [selectedCurrency]="defaultFiat"
                    [fiatRates]="fiatRates">
</app-token-selector>


<style>
  ::-webkit-scrollbar {
    display: none;
  }

  .form-control-lg {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
    font-size: 1rem;
  }

  select option {
    white-space: pre-line;
  }

  select option {
    white-space: pre-line;
  }

    select option::after {
      content: attr(data-balance);
      display: block;
      font-size: 0.75rem;
      color: #16a34a;
      text-align: right;
    }
</style>
